<template>
  <div class="box4">
    <div class="box4block" ref="block"></div>
    <div class="box4-top">
      <pageTitle title="采用必修+拓展模式授课<br/>高效就业、灵活提升" />
    </div>
    <div class="box4-title">
      <p>必修课<b> · 成为新时代复合型开发者</b></p>
      <img src="../../../assets/coursePage/java/box4/leg.png" />
    </div>
    <div class="box4-btm-box">
      <div class="box4-btm">
        <div
          class="subject-box"
          v-for="(item, index) in subject"
          :key="index"
          :style="{
            backgroundColor:
              cur == index && showAnswer ? '#fff' : 'transparent',
          }"
        >
          <div class="subject" @click="changeCur(index)" ref="item">
            <div class="title">
              <!-- <p v-show="item.stage">{{ item.stage }}</p> -->
              <span>{{ item.title }}</span>
            </div>
            <div
              class="icon"
              :class="{ 'img-rotate': cur == index && showAnswer }"
            >
              <img src="../../../assets/coursePage/ai/box6/icon-down.png" alt />
            </div>
          </div>

          <div
            class="course-content"
            :class="{ 'show-answer': cur == index && showAnswer }"
          >
            <div class="line"></div>
            <template v-if="item.multipleArr">
              <div class="tab">
                <a
                  v-for="(itemInner, indexInner) in item.multipleArr"
                  :key="indexInner"
                  :class="tabIndex == indexInner ? 'current' : ''"
                  @click="changeTabCur(indexInner)"
                  >{{ itemInner.tab }}</a
                >
              </div>
              <div v-if="item.multipleArr[tabIndex]">
                <div class="title-icon">
                  <img
                    src="../../../assets/coursePage/java/box4/01.png"
                    alt
                  />主要内容
                </div>
                <div class="main-content">
                  <div
                    class="block"
                    v-for="i in item.multipleArr[tabIndex].content"
                    :key="i"
                  >
                    {{ i }}
                  </div>
                </div>

                <div class="title-icon">
                  <img
                    src="../../../assets/coursePage/java/box4/02.png"
                    alt
                  />特色亮点
                </div>
                <div class="main-text">
                  <p v-for="j in item.multipleArr[tabIndex].light" :key="j" v-html="j">
                  
                  </p>
                </div>

                <div class="title-icon">
                  <img
                    src="../../../assets/coursePage/java/box4/03.png"
                    alt
                  />可掌握的能力
                </div>
                <div class="main-text">
                  <p v-for="k in item.multipleArr[tabIndex].ability" :key="k">
                    {{ k }}
                  </p>
                </div>
              </div>
            </template>
            <div v-else>
              <div class="title-icon">
                <img
                  src="../../../assets/coursePage/java/box4/01.png"
                  alt
                />主要内容
              </div>
              <div class="main-content">
                <div
                  class="block"
                  v-for="i in item.content"
                  :key="i"
                >
                  {{ i }}
                </div>
              </div>

              <div class="title-icon">
                <img
                  src="../../../assets/coursePage/java/box4/02.png"
                  alt
                />特色亮点
              </div>
              <div class="main-text">
                <p v-for="j in item.light" :key="j" v-html="j" :class="j.indexOf('<i>')>-1?'three':''"></p>
              </div>

              <div class="title-icon">
                <img
                  src="../../../assets/coursePage/java/box4/03.png"
                  alt
                />可掌握的能力
              </div>
              <div class="main-text">
                <p
                  v-for="k in item.ability"
                  :key="k"
                  :class="{ 'no-indent': !/^\d+\./.test(k) }"
                >{{ k }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="btn" @click="openDetail">查看详细大纲</div>
    </div>
    <div class="box4-title" style="margin-top: 0;">
      <p>拓展课<b> · 提升职场竞争力</b></p>
      <a>免费赠送</a>
    </div>
    <div class="box4-btm-box">
      <div class="box4-btm">
        <div
          class="subject-box"
          v-for="(item, index) in subject2"
          :key="index"
          :style="{
            backgroundColor:
              cur2 == index && showAnswer ? '#fff' : 'transparent',
          }"
        >
          <div class="subject" @click="changeCur2(index)" ref="item">
            <div class="title">
              <!-- <p v-show="item.stage">{{ item.stage }}</p> -->
              {{ item.title }}
            </div>
            <div
              class="icon"
              :class="{ 'img-rotate': cur2 == index && showAnswer }"
            >
              <img src="../../../assets/coursePage/ai/box6/icon-down.png" alt />
            </div>
          </div>

          <div
            class="course-content"
            :class="{ 'show-answer': cur2 == index && showAnswer }"
          >
            <div class="line"></div>
            <template v-if="item.multipleArr">
              <div class="tab">
                <a
                  v-for="(itemInner, indexInner) in item.multipleArr"
                  :key="indexInner"
                  :class="tabIndex == indexInner ? 'current' : ''"
                  @click="changeTabCur(indexInner)"
                  >{{ itemInner.tab }}</a
                >
              </div>
              <div  v-if="item.multipleArr[tabIndex]">
                <div class="title-icon">
                  <img
                    src="../../../assets/coursePage/java/box4/01.png"
                    alt
                  />主要内容
                </div>
                <div class="main-content">
                  <div
                    :class="[
                      index == 4 ||
                      index == 6 ||
                      index == 7 ||
                      index == 8 ||
                      index == 9
                        ? 'main-text2'
                        : 'block',
                    ]"
                    v-for="i in item.multipleArr[tabIndex].content"
                    :key="i"
                  >
                    {{ i }}
                  </div>
                </div>

                <div class="title-icon">
                  <img
                    src="../../../assets/coursePage/java/box4/02.png"
                    alt
                  />特色亮点
                </div>
                <div class="main-text">
                  <p v-for="j in item.multipleArr[tabIndex].light" :key="j">
                    {{ j }}
                  </p>
                </div>

                <div class="title-icon">
                  <img
                    src="../../../assets/coursePage/java/box4/03.png"
                    alt
                  />可掌握的能力
                </div>
                <div class="main-text">
                  <p v-for="k in item.multipleArr[tabIndex].ability" :key="k">
                    {{ k }}
                  </p>
                </div>
              </div>
            </template>
            <div v-else>
              <div class="title-icon">
                <img
                  src="../../../assets/coursePage/java/box4/01.png"
                  alt
                />主要内容
              </div>
              <div class="main-content">
                <div
                  :class="[
                    index == 4 ||
                    index == 6 ||
                    index == 7 ||
                    index == 8 ||
                    index == 9
                      ? 'main-text2'
                      : 'block',
                  ]"
                  v-for="i in item.content"
                  :key="i"
                >
                  {{ i }}
                </div>
              </div>

              <div class="title-icon">
                <img
                  src="../../../assets/coursePage/java/box4/02.png"
                  alt
                />特色亮点
              </div>
              <div class="main-text">
                <p v-for="j in item.light" :key="j">{{ j }}</p>
              </div>

              <div class="title-icon">
                <img
                  src="../../../assets/coursePage/java/box4/03.png"
                  alt
                />可掌握的能力
              </div>
              <div class="main-text">
                <p v-for="k in item.ability" :key="k">{{ k }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import check from "../../../utils/check";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  data() {
    return {
      tabIndex: 0,
      subject: [
        {
          stage: "阶段一",
          title: "Java核心与AI开发基础",
          content: [
            "Java基础语法",
            "AI辅助工具",
            "程序流程控制",
            "数组",
            "面向对象",
            "常用API",
            "商品管理系统",
          ],
          light: [
            "1. 在本阶段的学习中，学生不仅能够掌握 Java 编程技术，更重要的是可以学会如何利用 AI 解决编程问题。比如，如何通过 AI 攻克个人难以解决的编程难题，如何借助 AI 实现自动化编程。这些能力的获得，将大幅提升开发效率与综合编程水平，进而增强同学们在职场上的竞争力",
            "2. 本阶段知识均以解决需求为导向，讲解不墨迹，思路清晰，案例极其丰富",
          ],
          ability: [
            "1. 掌握Java程序的开发步骤",
            "2. 掌握企业里的开发工具：IDEA的基本使用，以及AI工具的使用",
            "3. 掌握Java程序的基本组成单元，以及基本语法",
            "4. 能够阅读并修改AI自动产生的各种Java代码",
            "5. 能够结合AI并运用所学的Java基础技术独立完成Java基础阶段的综合小项目",
          ],
        },
        {
          stage: "阶段二",
          title: "Java核心与AI开发进阶",

          content: [
            "集合",
            "异常",
            "File类",
            "常用API",
            "IO流",
            "多线程",
            "网络编程",
            "Java高级技术",
          ],
          light: [
            "1. JavaSE进阶阶段的内容更加深入，案例更加丰富，会涉及到底层源码和设计模式的讲解",
            "2. 本阶段课程为了保证学生的学习效果和解决实际需求的场景，均采用讲A练B的学习模式，比如课上通过讲解A项目讲解某些Java技术点，课下会提供B项目让学生练习",
            "3. 学完本阶段，你将至少获得如下能力：",
            "<i>a. 熟练掌握Java语言的基础编程，深度理解Java语言的设计思想</i>",
            "<i>b. 初步具备运用AI来解决Java编程需求的能力，并可以阅读、修改AI自动产生的各种Java程序</i>",
          ],
          ability: [
            "1. 掌握Collection、Map集合的定义和常用API",
            "2. 掌握项目开发中异常的正确处理方式",
            "3. 掌握自定义异常的方式",
            "4. 掌握File类的使用方式",
            "5. 掌握企业项目开发的常用API和IO流",
            "6. 掌握多线程的创建和使用",
            "7. 掌握线程池的创建和使用",
            "8. 掌握反射的作用和使用方式",
            "9. 掌握自定义注解的原理和使用场景",
            "10. 理解动态代理的好处，能够编写动态代理程序",
            "11. 理解集合底层原理",
            "12. 理解网络编程思想，能够自己编写出简单的TCP通信程序",
          ],
        },
        {
          stage: "阶段三",
          title: "AI赋能Web开发",

          content: [
            "HTML",
            "CSS",
            "JS",
            "Ajax",
            "Axios",
            "Maven",
            "MySQL",
            "JDBC",
            "Mybatis",
            "SpringBoot",
            "Spring",
            "SpringMVC",
            "Vue3",
            "ElementPlus",
            "Linux",
            "Docker",
            "Tlias智能学习辅助系统",
          ],
          light: [
            "1. 企业级项目驱动教学：基于SpringBoot3最新技术栈，通过真实商业项目案例贯穿教学，每个知识点均匹配实际应用场景，确保学完即用、无缝对接企业开发需求。知识点讲解循序渐进，重视知识通用性讲解，能够举一反三，重视能力的培养",
            "2. 全流程开发能力培养：系统化构建学员从需求拆解、编码实现、测试验证到服务器部署的完整Web开发认知体系，掌握软件生命周期核心方法论",
            "3. AI全链路开发提效：将AI深度整合到需求分析、数据库设计、代码生成、接口联调等全开发环节，显著提升开发效率，培养智能编程时代的核心竞争力",
            "4. 工业级开发规范内化：在项目实战中渗透代码规范、接口文档、测试用例等企业级工程标准，培养符合行业要求的职业化开发素养",
          ],
          ability: [
            "1. 需求分析与AI辅助开发能力：能够精准拆解项目需求，转化为自然语言描述，并熟练运用AI工具完成需求分析、代码生成、Bug修复等全流程开发任务",
            "2. 全栈开发与工程实践能力：熟练掌握基于SpringBoot3+Vue3的前后端分离架构，具备从系统设计、开发到容器化部署的前端架构实战能力",
            "3. 典型业务场景解决方案能力：掌握用户认证、对象存储等Web项目高频业务场景的标准化实现方案",
            "4. 云原生部署与运维能力：能够基于Linux+Docker完成前后端项目的环境配置、容器化部署",
            "5. AI提效开发方法论：深入理解AI辅助开发模式，能通过智能工具显著提升设计、编码效率，以及故障排查速度",
          ],
        },
        {
          stage: "阶段四",
          title: "企业级智能物联网项目（中州养老）",

          content: [
            "中州养老是一个智能化养老服务管理系统，主要面向养老服务机构，提供信息化管理方案，实时掌握老人健康和护理情况，提升服务质量和管理效率。项目还涉及表结构、接口和单体架构设计，以及接口性能、索引优化等高级内容",
          ],
          light: [
            "1. 课程全程采用 AI 工具辅助开发",
            "2. 课程讲解重点培养系统设计能力，包含了数据库设计、接口设计、技术方案设计等",
            "3. 课程采用低代码平台若依框架，实现快速开发和部署",
            "4. 课程中对接了百度千帆大模型，为解决实际业务挑战提供高效助力",
            "5. 课程包含了前端 Vue3+Element plus 组件完成页面开发，助你向全栈工程师靠拢",
            "6. 通过开发复杂业务，让你具备性能优化、接口优化、SQL 优化的能力，使系统更高效",
            "7. 注重代码质量，选择合适的设计模式调整代码结构，让你的代码更简洁，易扩展",
            "8. 采用了 RBAC 模型+Spring security 完成权限认证，让你掌握后台管理系统权限的通用解决方案",
            "9. 采用华为云物联网 IOT 平台，让你掌握智能硬件数据监测全流程",
            "10. 采用 MOTT 协议异步接收 IOT 平台的海量数据，让你掌握异步消息的处理",
            "11. 项目开发与实际项目开发接轨，采用敏捷式开发模式，让你掌握项目实际的开发流程",
            "12. 真实还原了项目上线之后的 bug 寻找定位，让你掌握更多线上 bug 调试方案",
            "13. 全程采用了项目开发常见工具，如:禅道、Git、Axure 等，让你无缝对接项目开发",
          ],
          ability: [
            "1. 系统设计能力，包含产品需求分析、数据库设计、接口设计、技术方案设计等方面",
            "2. 前端Vue3开发能力，包含了与后端接口对接联调、组合式API使用等能力",
            "3. 系统优化能力，包含了性能优化、接口优化、SQL优化等能力",
            "4. 解决问题的能力，包含了bug调试能力、在线调试工具使用能力等",
            "5. Git使用能力，包含了Git分支管理、团队协作开发等能力",
            "6. 项目部署能力，包含了项目打包，多环境、CICD持续集成部署能力",
          ],
        },
        {
          stage: "阶段五",
          title: "Vibe Coding零代码AI应用开发",
          content: [
            "系统讲解人工智能与大模型基础、智能体核心原理、Token计费机制与Vibecoding氛围编程逻辑；全方位实操Coze零代码平台、Dify开源LLM平台、RAGFlow企业级知识库三大主流工具，掌握模型参数调优、插件开发、可视化工作流编排、多模态数据处理、数据库接入、MCP协议对接、复杂文档解析等核心技能；结合简历智能助手、中州养老AI智能体两大商用项目，完成零基础AI智能体搭建、企业级RAG系统优化与全流程落地实战",
          ],
          light: [
            "1. 全平台技术全覆盖，一站式掌握Coze、Dify、RAGFlow三大行业主流AI开发平台，适配不同企业层级开发场景，技术覆盖面广、实用性极强",
            "2. 阶梯式闭环教学体系，从AI基础理论认知、零代码可视化实操，到开源平台开发、企业级知识库优化，循序渐进搭建完整AI开发技术体系，零基础也能稳步进阶",
            "3. 针对性解决行业技术痛点，掌握RAGFlow+Dify协同开发架构，突破传统知识库对扫描件、复杂表格、图文混排文档识别检索的技术短板",
          ],
          ability: [
            "1. 吃透大模型、AI智能体底层核心概念，熟练掌握Token计费规则与Vibecoding氛围编程逻辑，建立标准化AI开发思维",
            "2. 精通Coze平台全流程开发，可独立完成模型参数调优、插件配置、可视化工作流搭建、多模态处理与数据库联动开发",
            "3. 熟练掌握Dify平台部署、工作流编排、原生RAG开发、大模型接入及MCP协议对接能力，具备企业级开源AI应用落地能力",
            "4. 掌握RAGFlow文档解析与知识库搭建技术，可解决复杂文档、扫描件的检索难题，搭建高性能企业级私有知识库系统",
            "5. 具备独立设计、开发、部署AI智能体的实战能力，可自主完成简历助手、行业专属智能体等商用项目的全流程落地与优化",
          ],
        },
        {
          stage: "阶段六",
          title: "AI应用开发（Python）&RAG智能体开发",
          multipleArr: [
            {
              tab: "AI应用开发（Python）",
              content: [
                "学习Python基础与进阶编程、PyMySQL数据库操作、FastAPI接口开发；掌握LangChain核心组件、提示词工程、工具调用、记忆机制；精通RAG全链路开发，结合保险行业智能问答项目，完成企业级AI应用全栈落地",
              ],
              light: [
                "1. 技术栈全面刚需，覆盖Python全栈开发、FastAPI接口服务、MySQL数据持久化、LangChain大模型应用，贴合企业AI开发岗位主流技术体系",
                "2. 理论与实战深度结合，所有知识点配套代码实操，打通编程、服务、数据库、大模型联动开发，形成完整工程化能力闭环",
                "3. 行业项目驱动教学，以商用RAG智能问答项目贯穿全程，技术可直接复用至知识库系统、企业智能体、AI问答场景，就业落地性强",
              ],
              ability: [
                "1. 熟练掌握Python基础与进阶语法，具备规范编写业务代码、处理异常、封装通用功能的工程化编程能力",
                "2. 熟练使用PyMySQL实现Python与MySQL数据交互，完成业务数据增删改查与持久化存储",
                "3. 掌握FastAPI高并发接口开发，可独立完成AI能力服务化封装与线上交付",
                "4. 精通LangChain核心组件，熟练运用提示词工程、工具调用、记忆管理、输出解析开发大模型基础应用",
                "5. 掌握RAG全链路工程开发，可独立完成文档处理、向量检索、知识库问答系统的搭建与调优",
              ],
            },
            {
              tab: "RAG智能体开发",
              content: [
                "学习企业级RAG分层架构与模块化设计，掌握多源数据处理、父子块文本分割、BGE向量嵌入、Milvus向量库应用、混合检索策略、Redis缓存优化、大模型集成与提示工程；结合RAGAS量化评估、日志监控、异常处理，基于FastAPI+WebSocket完成生产级RAG智能问答系统的全流程搭建、调优与部署",
              ],
              light: [
                "1. 前沿架构实战落地，采用行业成熟RAG工程架构，完整覆盖数据处理、检索优化、模型集成、服务上线全流程",
                "2. 强化AI架构思维，重点讲解分层架构、模块化封装、多数据库协同、接口规范等企业级落地标准",
                "3. 多模型技术融合，整合BERT分类、BGE嵌入、通义千问大模型，构建完整AI检索问答技术生态",
                "4. 多样化检索策略，实现HyDE、子查询、回溯检索等多种增强方案，适配复杂用户问答场景",
                "5. 标准化工程体系，涵盖缓存优化、日志监控、性能评测、自动化测试，完全对标生产级项目规范",
              ],
              ability: [
                "1. 掌握企业级RAG项目搭建、功能调试与工程化部署全流程，具备完整项目落地能力",
                "2. 熟练使用Milvus向量数据库，掌握向量索引、相似度计算、稀疏&稠密混合检索开发",
                "3. 精通大模型集成与提示工程优化，可针对业务场景定制问答效果",
                "4. 掌握Redis缓存架构优化，有效提升系统检索速度与接口响应性能",
                "5. 掌握RAGAS评估框架，能够量化分析系统指标、完成性能迭代优化",
                "6. 具备多格式文档解析、长文本分层处理、多数据源协同开发的企业级实战能力",
                "7. 熟练基于FastAPI+WebSocket搭建流式问答、会话管理的生产级AI服务",
              ],
            },
          ],
        },
        {
          stage: "阶段七",
          title: "企业级项目智能化升级（A2A）",
          content: [
            "聚焦多智能体协同中台AgentCenter实战，基于LangGraph框架从零搭建企业级智能体服务中台。系统学习路由智能体、Tool Calling工具调用、A2A多智能体协议、MCP通信协议、RAG知识库检索等核心技术；结合PostgreSQL会话持久化、网关高可用架构、标准化工具封装，完成天机学堂原有业务系统智能化升级，实现智能课程咨询、个性化推荐、自动化交易、知识问答全场景AI能力落地",
          ],
          light: [
            "1. 中台化智能体架构，从零搭建AgentCenter智能服务中台，支持多业务系统快速接入智能化能力",
            "2. 双主流技术方案实战，融合LangGraph工作流与A2A多智能体协议，适配企业多租户、高并发业务场景",
            "3. 企业级高可用架构，内置网关认证、限流、熔断、负载均衡，对标生产级中台服务标准",
            "4. 标准化协议集成，基于MCP协议统一封装业务工具，实现多框架、多智能体体系无缝打通",
            "5. 全链路工程实战，覆盖智能体开发、路由编排、会话记忆、知识库检索、网关部署、业务集成完整流程",
            "6. 垂直场景深度落地，依托天机学堂教育业务，打造可商用的AI智能咨询、推荐、交易服务闭环",
          ],
          ability: [
            "1. 精通天机学堂业务架构，具备LangGraph框架项目集成与智能体二次开发能力",
            "2. 掌握流式对话、会话管理、生成中断等企业级智能交互全功能开发",
            "3. 熟练使用PostgreSQL Checkpointer实现对话上下文持久化与会话历史管理",
            "4. 掌握Tool Calling工具调用开发，可实现课程查询、卡片展示等AI业务联动能力",
            "5. 能够对接EduRAG外部知识库，实现智能问答与个性化课程推荐业务落地",
            "6. 具备AgentCenter智能体中台搭建、架构设计与业务系统快速对接能力",
            "7. 吃透六种智能体架构模型，熟练开发LangGraph路由工作流复杂智能体",
            "8. 掌握A2A协议开发，具备独立智能体服务搭建与多智能体协同调度能力",
            "9. 精通MCP协议原理，可独立完成MCP客户端、服务端开发与项目集成部署",
          ],
        },
        {
          stage: "阶段八",
          title: "微服务SCA",
          content: [
            "SpringCloud Aliaba",
            "Nacos",
            "OpenFeign",
            "Spring Cloud Gateway",
            "Seata",
            "Sentinel",
            "ElasticSearch",
            "Redis高级",
            "微服务项目常见技术方案",
            "常见面试题",
          ],
          light: [
            "1. 结合电商项目讲解企业从单体到微服务的真实拆分演进过程",
            "2. 分层次教学，重点讲解企业微服务开发中最实用、频率最高的知识和最佳实践方案，面试内容统一总结",
            "3. 结合真实项目学习，不仅学会，更要把知识用起来",
            "4. 使用AI辅助编程训练，学习效率大大提升",
          ],
          ability: [
            "1. 掌握SpringCloud Alibaba微服务技术栈",
            "2. 掌握高可靠性的消息队列方案",
            "3. 掌握分布式搜索解决方案",
            "4. 掌握Redis高级知识及底层原理",
            "5. 掌握微服务热点难点面试题及底层原理",
            "6. 掌握单体项目迁移至微服务项目常见技术方案",
          ],
        },
        {
          stage: "阶段九",
          title: "互联网分布式项目",
          content: [
            "云岚到家是一个家政服务O2O平台，通过移动互联网连接家政人员和用户，支持在线下单、接单、抢单和上门服务。平台包含用户端（小程序）、服务端（App）、机构端（PC）和运营管理端（PC），采用前后端分离开发模式。后端基于Spring Cloud Alibaba架构，涵盖订单管理、派单、抢单、客户管理、优惠券、运营基础、公共和支付服务等模块",
          ],
          light: [
            "1. 学员实战时可采用AI助手辅助开发，包括AI辅助设计、AI编码、AI代码审查、AI单元测试、AI代码优化等，大幅度提升开发效率",
            "2. 项目采用主流的SpringBoot、Spring Cloud Alibaba技术栈，适用于大多数企业对单体项目及微服务项目的技术选型，学完可快速应用到企业开发中",
            "3. 课程内容全面，包括：需求分析、设计、开发、测试、系统优化、运维等，学完将掌握Java中高级程序员在整个项目生命周期中所具备的重要技能",
            "4. 课程采用渐进式设计模式，保证零基础小白从入门到精通循序渐进掌握大型项目的实战能力",
            "5. 课程采用多项目教学，课堂授课与项目实战共涉及五个项目十几个业务模块，注重业务领域的深度学习及业务领域的迁移训练；注意业务解决方案与技术解决方案融合，讲授二十余个技术方案且通用性强，适合进行技术方案迁移",
          ],
          ability: [
            "1. 掌握系统需求分析的流程与方法",
            "2. 掌握根据产品原型进行系统设计的方法",
            "3. 掌握基于三层架构的开发方法",
            "4. 掌握使用AI工具进行项目设计、编码、优化的开发方法",
            "5. 掌握运营基础管理模块的设计与开发方法",
            "6. 掌握客户管理模块的设计与开发方法",
            "7. 掌握门户模块的设计与开发方法",
            "8. 掌握订单管理模块的设计与开发方法",
            "9. 掌握支付模块的设计与开发方法",
            "10. 掌握优惠券活动管理模块的设计与开发方法",
            "11. 掌握抢券模块的设计与开发方法",
            "12. 掌握抢单模块的设计与开发方法",
          ],
        },
        {
          stage: "阶段十",
          title: "面试指导和就业加强",
          content: [
            "简历指导",
            "面试专题题库",
            "项目专题强化训练",
            "全真模拟面试",
            "一对一面试辅导",
          ],
          light: [
            "1. 面试指导贯穿全程学习阶段，循序渐进夯实技术功底，优化项目表述专业度",
            "2. 采取分阶段、分批次、小组化模式常态化开展面试实战演练",
            "3. 一对一全真企业模拟面试，多角度查漏补缺、全面针对性辅导",
            "4. 提供符合行业招聘标准的高质量简历范本库，参考对标优化",
            "5. 开设项目专项打磨课程，配套面试全程跟踪、面试复盘优化",
          ],
          ability: [
            "1. 实现简历技术描述、项目包装、工作经验表述全方位提档升级",
            "2. 攻克面试高频核心考题，熟悉完整面试流程，积累实战面试经验",
            "3. 强化项目讲解能力，提升业务理解深度，理顺项目架构讲解逻辑",
          ],
        },
        {
          stage: "阶段十一",
          title: "大模型微调开发",
          content: [
            "微调全流程",
            "模型与 GPU 选型",
            "datasets",
            "transformers",
            "Trainer",
            "BERT",
            "JSONL",
            "Tokenizer",
            "文本分类",
            "参数调优",
            "评估指标",
            "NER 命名实体识别",
            "LoRA",
            "大模型指令微调",
            "模型部署",
          ],
          light: [
            "1. 覆盖从本地 / 云端环境搭建到模型训练、评估、生产部署的完整微调链路",
            "2. 核心技术深度实战，精通 transformers 工具链与 LoRA 高效微调，掌握 BERT 文本分类、NER 任务",
            "3. 注重工程化落地，教授模型调优、问题排查技巧，实现微调模型的接口封装与生产上线",
          ],
          ability: [
            "精通大模型 LoRA 高效微调全流程，掌握主流工具库，能独立完成模型训练与生产级部署",
          ],
        },
      ],
      subject2: [
        {
          stage: "阶段一",
          title: "星辰WMS",
          content: [
            "基于跨境电商智能仓储业务，从零搭建企业级WMS管理平台。系统学习前后端分离开发、Jeecg低代码应用、物联网监控、任务调度、文件存储、第三方接口对接；掌握Redis缓存、时序数据库、MQTT、分布式锁、多线程等高并发解决方案；结合NLP与大模型能力，实现AI智能仓储助手与智能体开发，完成全业务模块落地与性能优化",
          ],
          light: [
            "1. AI全流程赋能开发，覆盖需求分析、数据库设计、代码生成、智能审查、性能调优，大幅提升工程开发效率",
            "2. 企业级技术栈全覆盖，基于Spring Boot主流架构，落地高并发、高可用、分布式业务解决方案",
            "3. 业务场景深度智能化，融合NLP问答、AI助手、智能体能力，实现传统仓储系统AI升级",
            "4. 完整项目全生命周期实战，从需求建模、开发测试到运维监控，形成闭环工程能力",
            "5. 分层渐进式教学，由基础到高阶架构实战，零基础可稳步进阶企业级开发水平",
            "6. 多方案可迁移复用，沉淀20+商用技术解决方案，适配仓储、物流、电商多行业场景",
          ],
          ability: [
            "1. 具备前后端分离项目从架构设计、业务开发到部署上线的全流程落地能力",
            "2. 可独立开发入库、出库、库存、调度等WMS核心业务模块，熟练拆解仓储业务需求",
            "3. 掌握物联网监控、MQTT通信、硬件对接能力，实现智能化仓储数据采集与监控",
            "4. 精通低代码平台快速开发与个性化改造，具备企业系统快速迭代能力",
            "5. 熟练运用Redis、时序数据库、分布式锁、任务调度解决高并发性能问题",
            "6. 掌握第三方物流接口、文件存储、Web打印等通用企业级对接方案",
            "7. 具备大模型集成、NLP智能问答、AI智能体开发能力，可实现传统业务系统智能化升级",
          ],
        },
        {
          stage: "阶段二",
          title: "Java+AI智能体应用开发",
          content: [
            "依托教育领域天机学堂AI智能体项目，系统学习大模型核心原理与主流平台接口对接。深耕SpringAI框架技术体系，掌握提示词工程、角色配置、Advisors增强、Tool Calling业务调用、RAG检索增强、ES知识库搭建、Redis会话记忆、流式对话交互；落地智能路由工作流、多智能体协同、MCP协议通信、多模态融合与私有化部署方案，完成Java+AI教育场景智能化项目全栈落地",
          ],
          light: [
            "1. 全覆盖大模型核心技术栈，整合Prompt工程、RAG检索增强、Function Calling、智能体工作流，兼顾原理与工程实战",
            "2. 基于SpringAI深度开发，融合微服务架构改造，搭建Java生态企业级AI中台，贴合后端AI开发主流落地方式",
            "3. 真实教育项目贯穿全程，打通OpenAI、阿里百炼、Ollama多模型混合对接，适配复杂企业级融合场景",
            "4. 聚焦前沿AI能力，深度实战多模态开发、私有化模型部署、智能体工作流架构设计，对标高阶岗位技术要求",
            "5. 输出全套生产级解决方案，覆盖知识库构建、多轮对话管理、流式并发响应、智能路由调度等核心难点",
          ],
          ability: [
            "1. 掌握大模型核心原理，熟练对接OpenAI、阿里云百炼等主流大模型接口，具备多平台适配能力",
            "2. 精通Prompt工程、角色设定与Advisors自定义增强，可精准优化AI输出效果与响应逻辑",
            "3. 熟练运用Tool Calling实现AI与业务系统联动，完成课程查询、业务咨询等场景智能化调用",
            "4. 掌握RAG检索增强+ES知识库搭建，实现教育场景智能问答与精准内容推荐",
            "5. 精通SpringAI普通对话、流式对话、中断控制等全场景交互开发，优化用户交互体验",
            "6. 掌握Redis会话存储与上下文管理，实现稳定可持续的多轮对话服务",
            "7. 具备智能路由工作流、多智能体协同开发能力，可搭建复杂业务AI智能体系统",
            "8. 掌握多模态融合、MCP协议通信、模型私有化部署与调优，具备企业级AI项目落地能力",
          ],
        },
        {
          stage: "阶段三",
          title: "分布式项目集",
          multipleArr: [
            {
              tab: "天机学堂",

              content: [
                "天机学堂是一个生产级的在线教育项目，是一家专注于非学历职业技能培训的“网校”。项目基于SpringCloudAlibaba微服务技术栈，包含在线教育、社交、电商等热点难点问题的企业解决方案，让我们的学员真正做到举一反三。同时项目的完整度、真实度、复杂度都与真实项目非常接近，教学过程遵循企业开发流程，旨在让学生体会真实企业开发，掌握微服务开发的常用技能。",
              ],
              light: [
                "1. 营造企业微服务开发环境，模拟企业内多服务器、多团队开发、部署过程",
                "2. 从进入公司拉取、阅读企业级代码，到自己开发功能，手把手带你度过“危险期”",
                "3. 分析需求和原型图，设计数据库表及实体，带你熟悉企业真实开发流程",
                "4. 拒绝技术堆叠式课程，真正做到技术为业务服务，游刃有余的用技术解决真实问题",
                "5. 利用Redis解决各种各样的问题，绝不仅仅是缓存和key-value存储",
                "6. 掌握电商项目优惠券系统设计方案，解决拆单、退费等热点、难点问题",
                "7. 多种设计模式的熟练应用",
                "8. 企业真实业务场景下的多线程并发编程、安全问题处理",
                "9. 融合在线教育、社交、电商等多种热门项目亮点、难点问题解决方案",
              ],
              ability: [
                "1. 掌握企业开发的基本模式",
                "2. 了解企业开发环境、持续集成环境的工作模式",
                "3. 掌握跨微服务的业务开发方式",
                "4. 学会基于产品原型和需求做业务流程分析",
                "5. 学会基于产品原型和需求做数据结构设计",
                "6. 学会基于产品原型和需求做接口设计",
                "7. 掌握在线教育项目中的学习辅助系统设计方案",
                "8. 掌握积分、排行榜等系统设计方案",
                "9. 掌握优惠券系统设计方案",
                "10. 掌握常用中间件在微服务开发中的各种使用方式",
              ],
            },
            {
              tab: "四方保险",

              content: [
                "四方保险是一个金融保险销售SaaS平台，通过移动互联网为保险销售公司和客户提供了线上保险销售、产品发布、推荐、保费计算、收益计算、核保、承保、理赔等全流程服务。平台包含用户端（小程序）和保险销售管理端（PC）。项目包含7大核心模块：保险发布、保费计算、收益试算、保司承保、合同订单、随心配服务、扣款计划，以及oauth2.0权限服务、统一支付平台、数据采集埋点、对象存储服务、规则引擎等微服务。",
              ],
              light: [
                "1. 让您进去金融项目圈，本项目是目前市场唯一金融保险全业务链的实战型项目。",
                "2. 提升复杂项目的设计能力，包括：业务需求提炼、数据库结构设计通用技巧，微服务功能抽取能力、功能接口设计技巧，让您拥有高级开发人员的开发能力。",
                "3. 项目提供多种通用组件的构建，包括：微服务的OAuth2.0权限设计、统一支付平台、数据采集方案、对象存储服务、规则引擎等，学习完成后可以轻松迁移到其他项目。",
                "4. 课程采用半实战的实施方式，课程重分析、设计、代码能力提升，采用分组实战贴合企业项目开发的学习模式，学习后可以轻松胜任企业工作。",
              ],
              ability: [
                "1. 掌握微服务项目业务需求分析能力",
                "2. 掌握微服务项目模块的拆分设计能力",
                "3. 掌握SpringCloud的企业级开发框架的应用能力",
                "4. 掌握SpringCache+Redis的优雅的缓存处理能力",
                "5. 掌握跨业务对象存储实现文件统一管理包括：安全、上传、分片、下载的开发能力",
                "6. 掌握基于Oauth2.0的统一微服权限管理的开发能力",
                "7. 掌握基于SpringCloud-Stream消息驱动使用RabbitMQ的开发能力",
                "8. 掌握基于多种支付三方构建统一支付平台的开发能力",
                "9. 掌握基于多种短信服务商构建统一短信服务平台的开发能力",
                "10. 掌握基于SpringCloud-Gateway+InfluxDB数据采集分析平台的开发能力",
                "11. 掌握使用规则引擎处理业务分析判断的开发能力",
                "12. 掌握Seata分布式事务控制开发能力",
              ],
            },
            {
              tab: "帝可得",

              content: [
                "帝可得是⼀个智能售货机项⽬，基于SpringCloud+MybatisPlus框架开发，并应用传智研究院⾃研的解决方案框架集 Elegent 解决接口幂等性、数据⼀致性、分布式锁、分布式事务、微服务模块解耦与异步调用，⽀付、权限、Token续期等企业开发中的通用问题。项⽬采用⼯业级物联⽹消息中间件EMQx，解决海量物联⽹设备消息通讯的问题。",
              ],
              light: [
                "1. 微服务权限解决方案",
                "2. 令牌续期解决方案",
                "3. 接口幂等性解决方案",
                "4. 数据⼀致性解决方案",
                "5. ⽀付解决方案",
                "6. 并发处理解决方案",
                "7. 微服务异步调用解决方案",
                "8. 分布式事务解决方案",
                "9. 物联⽹消息传输解决方案",
                "10. 地理位置搜索解决方案",
                "11. 数据同步解决方案",
                "12. 搜索解决方案",
              ],
              ability: [
                "1. 了解需求评审会的场景与常见问题",
                "2. 根据产品原型分析和理解项⽬整体需求",
                "3. 基于库表设计方法论进⾏库表设计",
                "4. 根据产品原型进⾏接口设计",
                "5. 熟练编写跨服务调用代码",
                "6. 熟练编写微服务异步调用的代码，理解ElegentAC框架的设计原理",
                "7. 掌握分布式事务的实现，理解ElegentACTX框架的设计原理",
                "8. 熟练掌握分布式锁的实现，理解ElegentLock框架的设计原理",
                "9. 掌握开发物联⽹项⽬的开发思路，熟练开发物联⽹项⽬",
                "10. 掌握在项⽬中对接和使用⽀付，理解ElegentPay框架的设计原理",
                "11. 掌握如何实现接口幂等性，理解ElegentIU 框架的设计原理",
                "12. 在项⽬中对接ElegentAuth实现权限控制，并理解ElegentAuth框架的设计原理",
                "13. 在项⽬中对接ElegentToken实现令牌签发、验签与续期，并理解ElegentToken框架的设计原理",
              ],
            },
            {
              tab: "工作流组件",

              content: [
                "工作流组件项目即是课程也是一个开源项目，基于SpringBoot+Activiti7+MybatisPlus框架开发，结合工作流+Lowcode(低代码)的前沿开发思想，在项目中给出了工作流+低代码表单整合、权限控制的解决方案，同时项目还深入Activiti7的应用，提供了开发者流程设计器、业务人员流程设计器、流程状态图、前加签、并加签、驳回等诸多功能的实现方案。项目还提供了流程中心微服务、流程设计器等开源工具，供你高效开发流程项目。学完项目后，可以带着工作流+低代码解决方案和开源工具到企业中解决实际问题，提升就业竞争力。",
              ],
              light: [
                "1. 采用了工作流+低代码的双重前沿架构",
                "2. 全面深入的应用BPNM+Activiti，真实还原企业工作流开发",
                "3. 提供了业务流程设计器、流程中心微服务等开源套件，帮助学员快速开发工作流功能",
                "4. 提供了架构设计模式、Netty等彩蛋供学员们深造学习",
                "5. 分层式课程设计，更适应多层次的学员学有所获",
                "6. 贯彻讲A练B模式，配套课后练习，让学员能够活学活用，快速提升动手能力",
                "7. 企业级实战练习，更进一步让学员能够活学活用，熟悉在企业级项目中集成工作流技术的能力",
              ],
              ability: [
                "1. 熟悉BPMN 36种图例",
                "2. 熟悉BPMN 条件分⽀、⽹关分⽀、协同分⽀的控制",
                "3. 掌握BPMN图例绘制复杂流程图的能力",
                "4. 了解OA系统的特点和核⼼功能的开发过程",
                "5. 掌握Activiti7 加签、抄送、驳回等22个办理功能的开发能力",
                "6. 掌握Activiti7 流程状态图的开发能力",
                "7. 掌握Lowcode低代码表单开发能力",
                "8. 掌握Activiti7与Lowcode低代码表单的整合能力",
                "9. 掌握⼀定的BPMN xml文件解析的能力",
                "10. 掌握⼀定的Activiti7 底层命令修改的能力",
                "11. 掌握⼀定的参数化单元测试的开发能力",
                "12. 掌握⼀定的编程式事务、事务传播的开发能力",
              ],
            },
          ],
        },
      ],
      cur: -1,
      cur2: -1,
      showAnswer: true,
      prevItemHeight: 0,
    };
  },
  methods: {
    openDetail() {
      if (localStorage.getItem(`detail-${check.getUrlParam("nid")}`)) {
        window.location.href = localStorage.getItem(
          `detail-${check.getUrlParam("nid")}`
        );
      } else {
        this.clickZiXun()
      }
      this.mai("JavaEE-就业课", "查看详细大纲", 0, null);
    },
    goTop(index) {
      window.scrollTo(
        0,
        this.$refs.item[index].offsetTop -
          this.$refs.block.offsetHeight -
          this.$refs.block.offsetHeight * 0.3 -
          this.prevItemHeight
      );
    },
    changeTabCur(index) {
      this.tabIndex = index;
    },
    changeCur2(index) {
      this.tabIndex = 0;
      this.cur = -1;
      const a = document.querySelector(".show-answer");
      if (a != null && index > this.cur) {
        this.prevItemHeight = a.offsetHeight;
      }
      if (!this.showAnswer || index <= this.cur) {
        this.prevItemHeight = 0;
      }
      if (index == this.cur2) {
        this.showAnswer = !this.showAnswer;
      } else {
        this.showAnswer = true;
        this.cur2 = index;
      }
      // console.log(this.$refs.item[index]);
      // console.log(this.$refs.item[index].offsetTop, this.prevItemHeight);
      // this.goTop(index);
    },
    changeCur(index) {
      this.tabIndex = 0;
      this.cur2 = -1;
      this.$nextTick(()=>{
        const a = document.querySelector(".show-answer");
        if (a != null && index > this.cur) {
          this.prevItemHeight = a.offsetHeight;
        }
        if (!this.showAnswer || index <= this.cur) {
          this.prevItemHeight = 0;
        }
        if (index == this.cur) {
          this.showAnswer = !this.showAnswer;
        } else {
          this.showAnswer = true;
          this.cur = index;
        }
        this.goTop(index);
      })
      
    },
    toLink() {
      window.open("https://m.boxuegu.com/");
    },
  },
};
</script>

<style lang="less" scoped>
.box4 {
  width: 750px;
  background: #edf3ff;
  .box4block {
    height: 80px;
  }
  .box4-top {
    position: relative;
  }
  .box4-title {
    position: relative;
    height: 96px;
    background: linear-gradient(270deg, #72b7fd 0%, #017fff 100%);
    box-shadow: 0px 0px 18px 0px #e2e7f1;
    border-radius: 16px;
    margin: 40px 32px 0;
    display: flex;
    align-items: center;
    p {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 36px;
      color: #ffffff;
      line-height: 96px;
      text-align: left;
      font-style: normal;
      padding-left: 40px;
      b {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 30px;
        color: #ffffff;
        line-height: 96px;
        text-align: left;
        display: line-block;
        font-style: normal;
      }
    }
    a {
      width: 180px;
      height: 52px;
      display: block;
      background: #ffffff;
      border-radius: 26px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 30px;
      color: #017fff;
      line-height: 52px;
      text-align: center;
      font-style: normal;
      margin-left: 74px;
    }
    img {
      width: 138px;
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }
  .leftbgc {
    width: 144px;
    height: 178px;
    background: rgba(237, 219, 166, 0.23);
    position: absolute;
    left: 0;
    top: 0;

    filter: blur(50px);
  }
  .rightbgc {
    width: 396px;
    height: 179px;
    background: rgba(166, 192, 237, 0.23);
    right: 0;
    top: 0;
    position: absolute;
    filter: blur(50px);
  }
  .topWrap {
    width: 686px;
    margin: 48px auto 0px;
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 240px;
      height: 164px;
      background-size: cover;
      margin-right: -18px;
      overflow: hidden;
      margin-bottom: 20px;
      .img {
        width: 48px;
        height: 52px;
        margin: 30px 0 12px 78px;
        background-size: cover;
      }
      p {
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
        line-height: 44px;
        margin-left: 78px;
      }
    }
  }
  .box4-btm-box {
    padding-bottom: 88px;
    width: 100%;
    padding-top: 48px;
    // background: linear-gradient(180deg, #ffffff 0%, #f2f6ff 5%, #f2f6ff 100%);
    .box4-btm {
    }
  }

  .btn {
    margin: 0 auto;
    margin-top: 48px;
    width: 480px;
    height: 88px;
    background: linear-gradient(270deg, #ff7a87 0%, #ff4659 100%);
    border-radius: 48px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 30px;
    color: #ffffff;
    line-height: 88px;
    text-align: center;
    font-style: normal;
  }

  .subject-box {
    margin: 0 auto;
    margin-bottom: 16px;
    width: 686px;
    overflow: hidden;
    border-radius: 16px;
  }
  .tab {
    display: flex;
    margin: 20px -12px 40px -12px;
    a {
      display: block;
      padding: 8px 22px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 26px;
      color: #4e5969;
      line-height: 36px;
      text-align: center;
      font-style: normal;
      margin-right: 12px;
      background: #e4f3ff;
      border-radius: 26px;
    }
    a:last-child {
      margin-right: 0;
    }
    .current {
      background: #0a5bff;
      box-shadow: 0px 8px 16px 0px #b3deff;
      color: #fff;
    }
  }
  .subject {
    display: flex;
    align-items: center;
    position: relative;
    padding: 22px 0px 22px 35px;
    padding-right: 22px;
    width: 100%;
    height: 96px;
    background: #ffffff;
    border-radius: 16px;
    box-sizing: border-box;
    z-index: 5;
    justify-content: space-between;

    .title {
      margin-right: 20px;

      display: flex;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #020941;
      line-height: 40px;
      p {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 600;
        line-height: 40px;
        color: rgba(64, 128, 255, 1);
        margin-right: 16px;
      }
    }

    .icon {
      width: 28px;
      height: 28px;
      transition: 0.5s ease all;
      margin-right: 5px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .img-rotate {
      transition: 0.5s ease all;
      transform: rotate(180deg);
    }

    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
  }

  .course-content {
    padding: 0px 24px;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    max-height: 0;
    opacity: 0;
    transition: 0.3s ease all;
    overflow: hidden;
    z-index: 3;
    padding: 0px 40px 0px;

    .line {
      margin-bottom: 28px;
      width: 622px;
      height: 1px;
      margin-left: -8px;
      background: #f2f3f5;
    }
  }

  .show-answer {
    padding: 0px 40px 0px;
    border-radius: 16px;
    // display: block;
    max-height: 3200px;
    opacity: 1;
    transition: 0.4s ease all;
  }

  .title-icon {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    height: 44px;
    font-size: 28px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: #1d2129;
    img {
      margin-right: 14px;
      width: 32px;
      height: 32px;
    }
  }

  .main-content {
    margin-bottom: 24px;
    display: flex;
    flex-wrap: wrap;
    // margin-left: 45px;
    .block {
      margin-bottom: 16px;
      margin-right: 16px;
      padding: 8px 16px;
      background: rgba(106, 161, 255, 0.1);
      border-radius: 10px;
      background: rgba(106, 161, 255, 0.1);
      border-radius: 10px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
    }
  }

  .main-text {
    margin-bottom: 40px;
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4e5969;
    line-height: 44px;
    // margin-left: 45px;

    p {
      text-indent: -27px;
      padding-left: 31px;
      // /deep/ i{
      //   margin-left: 31px;
      //    text-indent: -31px;
      //   padding-left: 62px;
      // }
    }
    .no-indent {
      text-indent: 0;
      padding-left: 0;
    }
    .three{margin-left: 31px;}
   
  }
   p:nth-child(10), p:nth-child(11), p:nth-child(12), p:nth-child(13), p:nth-child(14) {
      text-indent: -40px;
      padding-left: 40px;
    }
  p:nth-child(11) {
    // text-indent: -40px;
    // padding-left: 40px;
    // margin-left: -7px;
  }
  .main-text2 {
    margin-bottom: 16px;
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4e5969;
    line-height: 44px;
  }
}
</style>
